
import { useState, useEffect } from 'react';
import API from '../api/api';

const useGetPrograms = (role) => {

    const [programs, setList] = useState([]);
    const [p_error, setError] = useState(null);
    const [p_loading, setLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            try {
                const request = await API.get('/get_programs');
                if (request.data.data) {
                    setList(request.data.data);
                } 
            }
            catch(error) {
              if (error?.status === 401) {
                  return;
                }
                if (error.status === 403) {return; } 
              setError(error);
          }
            finally {
                setLoading(false);
            }
        }
        loadData();
    }, [role]) 
    
    return { programs, p_loading, p_error };
}

export default useGetPrograms;